import React, { Component } from 'react'
import AddBudget from './addBudget'
import { CloseOutlined, EditOutlined } from '@ant-design/icons'
import { Input, Button, message } from 'hljd'
import {
  PROPERTY_WITH_WEDDING_OBJ,
  PROPERTY_WITH_WEDDING
} from '../../constant'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
const TextArea = Input.TextArea

@observer
class Budget extends Component {
  moneyFormat = value => {
    let num = `${value}`
    // 只能输入数字
    let lastStr = num.slice(-1)
    if ((lastStr < '0' || lastStr > '9') && lastStr !== '.') {
      return num.slice(0, -1)
    }
    return num
  }

  setTotalBudget = index => {
    const value = this.props.getFieldsValue()
    let total = 0
    const budgetList = this.props.budgetList
    budgetList.forEach((item, idx) => {
      if (index !== idx) {
        const budgetMoney = value[`budget-${item.property_id || item.id}`]
        total += budgetMoney ? Number(budgetMoney) : 0
      }
    })
    total && this.props.setFieldsValue({ totalBudget: total })
  }

  onInputBlur = () => {
    this.setTotalBudget()
  }

  onBudgetItemChange = value => {
    this.props.store.onBudgetItemChange(value)
  }

  delBudgetItem = index => {
    this.setTotalBudget(index)
    this.props.store.delBudgetItem(index)
    const value = this.props.getFieldsValue()
    let budgetType = value.budgetType
    budgetType.splice(index, 1)
    this.props.setFieldsValue({ budgetType })
  }

  getBudget = () => {
    const { setFieldsValue } = this.props
    const { totalBudget } = this.props.getFieldsValue(['totalBudget'])
    const budgetList = toJS(this.props.store.budgetList)
    if (Number(totalBudget) <= 0) {
      return message.error('请填写总预算')
    }
    const budgetTpeyInitValue = budgetList.map(
      item => item.property_id || item.id
    )
    this.props.store.getBudget(
      {
        budget_money: totalBudget,
        property_ids: budgetTpeyInitValue.join(',')
      },
      data => {
        setFieldsValue(data)
      }
    )
  }
  render() {
    const {
      getFieldDecorator,
      budgetList,
      detailData,
      showBudgetList,
      store
    } = this.props
    const budgetTpeyInitValue = budgetList.map(
      item => item.property_id || item.id
    )

    const showBudgetType = budgetList.length < PROPERTY_WITH_WEDDING.length

    return (
      <div className="budget-wrap">
        <div
          className="add-budget-btn"
          style={{ display: showBudgetList ? 'none' : 'block' }}
          onClick={() =>
            store.setStoreData([{ type: 'showBudgetList', value: true }])
          }
        >
          <i className="icon iconfont icon-add" />
          <div>点击记录需求</div>
        </div>
        <div
          className="item-shadow"
          style={{ display: showBudgetList ? 'block' : 'none' }}
        >
          <div className="item-wrap clearfix">
            <span className="label">总预算&nbsp;:&nbsp;</span>
            <div className="btn-box">
              {getFieldDecorator('totalBudget', {
                initialValue: detailData.budget_money_sum || '',
                getValueFromEvent: e => this.moneyFormat(e.target.value)
              })(
                <Input
                  type="text"
                  style={{ width: '160px', marginRight: '20px' }}
                />
              )}
              <Button type="primary" onClick={this.getBudget}>
                自动分解
              </Button>
              {getFieldDecorator('budgetType', {
                initialValue: budgetTpeyInitValue
              })(
                <AddBudget
                  show={showBudgetType}
                  onOk={this.onBudgetItemChange}
                />
              )}
            </div>
          </div>
          {budgetList.map((item, index) => {
            return (
              <div key={index} className="item-wrap">
                <span className="label">
                  {PROPERTY_WITH_WEDDING_OBJ[item.property_id || item.id]}&nbsp;:&nbsp;
                </span>
                <div className="input-box question">
                  <div className="input-left">
                    <div>需求问卷</div>
                    <div
                      className="edit-icon"
                      onClick={() =>
                        this.props.store.questionDrawerStore.toggleQuestionnaire(
                          item.property_id || item.id
                        )
                      }
                    >
                      {item.survey_answer && item.survey_answer.length ? (
                        <span>{`${item.survey_answer.length} / ${
                          item.questions
                            ? item.questions.length
                            : item.survey.question_total_num
                        }`}</span>
                      ) : (
                        <span>填写</span>
                      )}
                      <EditOutlined />
                    </div>
                  </div>
                  <div className="input-left">
                    <div>预算</div>
                    {getFieldDecorator(
                      `budget-${item.property_id || item.id}`,
                      {
                        initialValue: item.budget_money || '',
                        getValueFromEvent: e => this.moneyFormat(e.target.value)
                      }
                    )(
                      <Input
                        type="text"
                        className="bugger-input"
                        placeholder="请输入"
                        onBlur={this.onInputBlur}
                      />
                    )}
                  </div>
                  {getFieldDecorator(`des-${item.property_id || item.id}`, {
                    initialValue: item.remark || ''
                  })(
                    <TextArea
                      className="input-right"
                      placeholder="请填写相关需求"
                    />
                  )}
                  <CloseOutlined
                    className="del-budget"
                    onClick={() => this.delBudgetItem(index)}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default Budget
